import {create} from 'zustand';

import {SaludiaDrawerStore} from './types';

export const useSaludiaDrawerStore = create<SaludiaDrawerStore>(set => ({
	activeSaludiaDrawer: null,
	returnToOptionsDrawer: true,
	origin: 'network-provider',
	openSaludiaDrawer: (drawer, {returnToOptionsDrawer = true, origin = 'network-provider'} = {}) =>
		set({activeSaludiaDrawer: drawer, returnToOptionsDrawer, origin}),
	closeSaludiaDrawer: () => set({activeSaludiaDrawer: null}),
}));
